<template>
  <!-- header:start -->
  <header id="header" class="header">
    <PCButtonHistoryBack />
    <div class="header-search">
      <div v-if="!state.isWLJOP" class="header-search-tab">
        <router-link
          to="/pc/contract"
          v-slot="{ href, navigate, isActive }"
        >
          <div :class="['header-search-tab-item', (isActive || state.isContract) && 'is-active']">
            <a :href="href" @click="navigate" class="text">契約情報</a>
          </div>
        </router-link>
        
        <router-link
          to="/pc/service"
          v-slot="{ href, navigate, isActive }"
        >
          <div :class="['header-search-tab-item', (isActive || state.isService) && 'is-active']">
            <a :href="href" @click="navigate" class="text">サービス管理</a>
          </div>
        </router-link>
      </div>
      <div class="header-search-tab header-search-tab-02">
        <router-link
          to="/pc/contract-account"
          v-slot="{ href, navigate, isActive }"
        >
          <div :class="['header-search-tab-item', (isActive || state.isAccount) && 'is-active']">
            <a :href="href" @click="navigate" class="text">利用者アカウント管理</a>
          </div>
        </router-link>

        <router-link
          to="/pc/contract-assign-license"
          v-slot="{ href, navigate, isActive }"
        >
          <div :class="['header-search-tab-item', (isActive || state.isLicense) && 'is-active']">
            <a :href="href" @click="navigate" class="text">ライセンス管理</a>
          </div>
        </router-link>
        
        <router-link
          v-if="!state.isWLJOP"
          to="/pc/contract-history-of-purchase"
          v-slot="{ href, navigate, isActive }"
        >
          <div :class="['header-search-tab-item', (isActive || state.isHistory) && 'is-active']">
            <a :href="href" @click="navigate" class="text">申し込み履歴</a>
          </div>
        </router-link>

        <router-link
          v-if="state.isInvoicingInformationAvailable"
          to="/pc/contract-invoicing-information"
          v-slot="{ href, navigate, isActive }"
        >
          <div :class="['header-search-tab-item', isActive && 'is-active']">
            <a :href="href" @click="navigate" class="text">ご請求案内</a>
          </div>
        </router-link>

        <router-link
          to="/pc/inquiry-input"
          v-slot="{ href, navigate, isActive }"
        >
          <div :class="['header-search-tab-item', isActive && 'is-active']">
            <a :href="href" @click="navigate" class="text">お問い合わせ</a>
          </div>
        </router-link>
      </div>
    </div>
  </header>
  <!-- header:end -->
</template>
<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'
import { isInvoicingInformationAvailable } from '@/logic/common/CommonPaymentMethod'
import * as _ from 'lodash'
export default defineComponent({

  setup (props, context) {
    const store = context.root.$store
    // パスからどのタブをアクティブにするか判定（下層ページ用）
    const state = reactive({
      path: context.root.$route.path,
      isContract: computed(() => {
        const lists = []
        return _.includes(lists, state.path)
      }),
      isService: computed(() => {
        const lists = [
          '/pc/service-detail',
          '/pc/contract-free-trial',
          '/pc/service-license-cancel-input'
        ]
        return _.includes(lists, state.path)
      }),
      isAccount: computed(() => {
        const lists = []
        return _.includes(lists, state.path)
      }),
      isLicense: computed(() => {
        const lists = []
        return _.includes(lists, state.path)
      }),
      isHistory: computed(() => {
        const lists = []
        return _.includes(lists, state.path)
      }),
      isWLJOP: computed(() => store.getters['profile/isWLJOP']),
      isInvoicingInformationAvailable: computed(() => {
        return isInvoicingInformationAvailable()
      })
    })

    return {
      state
    }
  }
})
</script>

<style lang="scss" scoped>
</style>
